<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="80px">
          <el-form-item label="会员ID" prop="memberId">
            <el-input placeholder="请输入会员ID" v-model="searchForm.memberId" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="username">
            <el-input placeholder="请输入用户名" v-model="searchForm.username" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input placeholder="请输入手机号" v-model="searchForm.mobile" clearable></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input placeholder="请输入邮箱" v-model="searchForm.email" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="正常" :value="0"></el-option>
              <el-option label="已禁用" :value="1"></el-option>
              <el-option label="已注销" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册时间">
            <el-date-picker
              v-model="searchForm.registerTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="status" label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)" effect="dark">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详情</el-button>
          <el-button
            v-if="scope.row.status === 0"
            type="text"
            size="small"
            @click="enableOrDisable(scope.row)">
            禁用
          </el-button>
          <el-button
            v-if="scope.row.status === 1"
            type="text"
            size="small"
            @click="enableOrDisable(scope.row)">
            启用
          </el-button>
          <el-button
            v-if="scope.row.status !== 2"
            type="text"
            size="small"
            style="color: #f56c6c;"
            @click="cancelMember(scope.row)">
            注销
          </el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>
  </div>
</template>

<script>
import { queryMemberList, enableOrDisableMember, cancelMember } from '@/api/member/memberApi'
import router from '@/router'

export default {
  name: 'memberList',

  data () {
    return {
      searchForm: {
        memberId: null,
        username: null,
        mobile: null,
        email: null,
        status: null,
        registerTimeRange: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '会员ID',
          prop: 'memberId',
          width: '100px'
        },
        {
          label: '用户名',
          prop: 'username',
          width: '150px'
        },
        {
          label: '手机号',
          prop: 'mobile',
          width: '130px'
        },
        {
          label: '邮箱',
          prop: 'email',
          width: '200px'
        },
        {
          slot: 'status'
        },
        {
          label: '注册时间',
          prop: 'registerTime',
          width: '160px'
        },
        {
          label: '最后登录',
          prop: 'lastLoginTime',
          width: '160px'
        },
        {
          slot: 'operate'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.registerTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      console.log('getTableData() start to fetch member list')
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.registerTimeRange && params.registerTimeRange.length === 2) {
        params.registerTimeStart = params.registerTimeRange[0]
        params.registerTimeEnd = params.registerTimeRange[1]
      }
      delete params.registerTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryMemberList(params).then((res) => {
        console.log('getTableData() receive response:', res)
        // 兼容两种响应结构：
        // 1. 标准结构 { code: 10000, data: { records: [], total: 0 } }
        // 2. 原始分页结构 { records: [], total: 0, ... }
        let records = []
        let total = 0

        if (res.code === this.$constant.SUCCESS) {
          records = res.data.records || []
          total = res.data.total || 0
        } else if (res.records) {
          // 如果直接返回分页对象
          records = res.records || []
          total = res.total || 0
        }

        // 字段映射：将 id 映射为 memberId，因为表格列定义和详情跳转使用的是 memberId
        this.tableData = records.map(item => {
          return {
            ...item,
            memberId: item.memberId || item.id
          }
        })
        this.pagination.total = total
        console.log(`getTableData() processed ${this.tableData.length} records`)
        this.loadingBtn.tableLoading = false
      }).catch((err) => {
        console.error('getTableData() error:', err)
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 查看详情
    viewDetail (row) {
      router.push({
        path: '/member/detail',
        query: { memberId: row.memberId }
      })
    },

    // 启用/禁用
    enableOrDisable (row) {
      const action = row.status === 0 ? '禁用' : '启用'
      this.$confirm(`是否确认${action}该会员?`, `确认${action}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        enableOrDisableMember(row.memberId).then(({ code, msg }) => {
          if (code === this.$constant.SUCCESS) {
            this.$message.success(msg || `${action}成功`)
            this.getTableData()
          }
        })
      }).catch(() => {})
    },

    // 注销会员
    cancelMember (row) {
      this.$confirm('注销后该会员将无法登录和使用系统，是否确认注销?', '确认注销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelMember(row.memberId).then(({ code, msg }) => {
          if (code === this.$constant.SUCCESS) {
            this.$message.success(msg || '注销成功')
            this.getTableData()
          }
        })
      }).catch(() => {})
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const statusMap = {
        0: 'success', // 正常
        1: 'warning', // 已禁用
        2: 'danger' // 已注销
      }
      return statusMap[status] || 'info'
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .listManager-btnGroup-wrap {
  margin-top: 20px;
  padding-top: 20px;
}
</style>
